iScreenWizard.controller('UitnodigingController', function ($rootScope, $scope, $state, $mdDialog, Dictionary, ErrorHandler, userService, Mailtemplate, nieuweTestafnameService, Testotheek, Klantorganisatie, Testafname) {

    $scope.userService = userService;
    $scope.backIsLosseTests = false;
    $scope.testafname = nieuweTestafnameService.model;
    $scope.mailtemplates = [];
    $scope.trixInitializeMailtemplateTags = $rootScope.trixInitializeMailtemplateTags;
    $scope.sending = false;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    $scope.refresh = function() {

        //skip testotheek if user doensnt have any tests in testotheek
        if (userService.isExpert()) {
            testotheekparams = {
                testafname_opleidingsniveau_id: $scope.testafname.kandidaat.opleidingsniveau.id
            };
            Testotheek.all(testotheekparams).then(function(tests) {
                //skip testotheek if user doensnt have any tests in testotheek
                if (tests.length > 0) {
                    $scope.backIsLosseTests = true;
                } else {
                    $scope.backIsLosseTests = false;
                }
            });
        } else {
            $scope.backIsLosseTests = false;
        }

        params = {
            testafname_taal_id: $scope.testafname.kandidaat.taal.id,
            testafname_rapporttemplate_id: $scope.testafname.rapporttemplate ? $scope.testafname.rapporttemplate.id : null,
            testafname_opleidingsniveau_id: $scope.testafname.kandidaat.opleidingsniveau.id,
            alleen_testotheek: ($scope.testafname.alleen_testotheek ? 1 : 0)
        };

        Mailtemplate.all(params).then(function (mailtemplates) {
            $scope.mailtemplates = mailtemplates;
            if (mailtemplates.length > 0) {
                $scope.testafname.mailtemplate = mailtemplates[0];
                $scope.selecteerMailtemplate(mailtemplates[0]);
            }
        });

    };

    $scope.selecteerMailtemplate = function(mailtemplate) {
        Klantorganisatie.current().then(function (klantorganisatie) {
            mailtemplate.inhoudhtml = mailtemplate.inhoudhtml
                .replace("{%FirstName%}", $scope.testafname.kandidaat.voornaam)
                .replace("{%LastName%}", $scope.testafname.kandidaat.achternaam)
                .replace("{%EmailAddress%}", $scope.testafname.kandidaat.email)
                .replace("{%LanguageName%}", $scope.testafname.kandidaat.taal.naam)
                .replace("{%GenderName%}", Dictionary.translate('app.sir_madam'))
                .replace("{%UserFirstName%}", userService.model.voornaam)
                .replace("{%UserLastName%}", userService.model.achternaam)
                .replace("{%UserName%}", userService.getUsername())
                .replace("{%CompanyName%}", klantorganisatie.naam);
            $scope.testafname.mailtemplate.inhoudhtml  = mailtemplate.inhoudhtml;
            $scope.testafname.mailtemplate.senderemail  = userService.model.email;
            $scope.testafname.mailtemplate.cc = '';
            $scope.testafname.mailtemplate.bcc = '';
        });
    };

    $scope.saveTestafname = function() {
        nieuweTestafnameService.SaveState();
    };

    $scope.storeTestafname = function() {
        $scope.sending = true;
        Testafname.store($scope.testafname).then(function(response) {
            if (ErrorHandler.hasErrors(response)) {
                ErrorHandler.showDialog(response);
            } else {
                nieuweTestafnameService.model = {};
                nieuweTestafnameService.SaveState();
                $state.go('home').then(function() {
                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title(Dictionary.translate('app.invitation_send', true))
                            .ariaLabel(Dictionary.translate('app.invitation_send', true))
                            .ok(Dictionary.translate('app.okay', true))
                    );
                });
            }
        });
    };

});